import { H3 } from '@/components/sv/typographies'
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const DatabaseManagePasswordSectionFallback = () => (
  <Card>
    <CardHeader>
      <H3>Manage password</H3>
      <CardDescription>
        <Skeleton className="h-5 w-230" />
      </CardDescription>
      <CardAction>
        <Skeleton className="h-9 w-42" />
      </CardAction>
    </CardHeader>
    <CardContent>
      <Skeleton className="h-5 w-44 mb-2" />
      <Skeleton className="h-9 w-full" />
    </CardContent>
  </Card>
)
